<div class="flex mx-[8px]">
	<button
		class="{{
			mainImageDisplay
				? ' relative'
				: 'border-dashed border-[2px] border-[#D9DBE9]'
		}} rounded-12px ltr:mr-[6px] rtl:ml-[6px]"
	>
		<div
			class="{{
				smallSize ? 'w-[132px] h-[132px]' : 'w-[200px] h-[200px]'
			}} flex items-center flex-nowrap relative"
		>
			<div class="flex-grow" (click)="uploadSliderImage(true)">
				<img
					class="m-auto"
					[src]="
						mainImageDisplay
							? attachmentUrl + mainImageDisplay
							: './assets/images/upload.svg'
					"
					alt=""
				/>
				<p *ngIf="!mainImageDisplay">
					{{ 'ACTIONS.UPLOAD_MAIN_IMG' | translate }}
				</p>
			</div>
			<div
				*ngIf="mainImageDisplay"
				(click)="mainImage.emit(''); mainImageDisplay = ''"
				class="absolute top-[5px] ltr:right-[5px] bg-off-white p-[4px] {{
					smallSize ? 'w-[24px]' : 'w-[30px]'
				}} rounded-full icon-shadow cursor-pointer text-center"
			>
				<img
					class="{{ smallSize ? 'max-w-[8px]' : 'max-w-[13px]' }} inline-block "
					src="./assets/images/Xicon.svg"
					alt=""
				/>
			</div>
			<div *ngIf="mainImageDisplay" class="absolute top-0 left-0">
				<div
					class="inline-block py-[2px] px-[6px] rounded-[50px] mb-[6px] bg-[#E2F5EE]"
				>
					<div
						class="rounded-full w-[5px] h-[5px] inline-block m-[2px] bg-[#00BA88]"
					></div>
					<p
						class="inline-block m-0 max-mobile:text-font-mobile-small text-[#00BA88] {{
							smallSize ? 'text-[10px]' : ''
						}}"
					>
						{{ 'STORE.ADD_PRODUCT.MAIN_IMAGE' | translate }}
					</p>
				</div>
			</div>
		</div>
	</button>

	<div
		class="relative {{ smallSize ? 'min-h-[132px]' : 'min-h-[200px]' }}  {{
			ProductData?.length > 2 && !smallSize
				? 'max-w-[75%]'
				: ProductData?.length > 3 && smallSize
				? 'max-w-[75%]'
				: 'w-full'
		}}   "
	>
		<div
			class="flex items-center space-x-4 overflow-x-auto {{
				ProductData?.length < 5 && !smallSize
					? 'w-[66%]'
					: ProductData?.length < 5 && smallSize
					? 'w-[80%]'
					: 'w-full'
			}}"
		>
			<!-- Images container with horizontal scroll -->
			<div class="flex whitespace-no-wrap">
				<!-- Individual image cards -->
				<ng-container *ngIf="ProductData?.length > 0">
					<div
						*ngFor="let image of ProductData"
						class="{{
							smallSize ? 'w-[132px] h-[132px]' : 'w-[200px] h-[200px]'
						}} border rounded-lg overflow-hidden mx-[8px]"
					>
						<div class="relative">
							<img
								[src]="attachmentUrl + image?.imageUrl"
								alt="Image 1"
								class="{{
									smallSize ? 'w-[132px] h-[132px]' : 'w-[200px] h-[200px]'
								}}"
							/>
							<div
								*ngIf="
									(mainProductSlider && ProductData.length > 1) ||
									!mainProductSlider
								"
								(click)="deleteImg(image)"
								class="absolute top-[5px] ltr:right-[5px] bg-off-white p-[4px] {{
									smallSize ? 'w-[24px]' : 'w-[30px]'
								}} rounded-full icon-shadow cursor-pointer text-center"
							>
								<img
									class="{{
										smallSize ? 'max-w-[8px]' : 'max-w-[13px]'
									}} inline-block "
									src="./assets/images/Xicon.svg"
									alt=""
								/>
							</div>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
		<div
			(click)="uploadSliderImage(false)"
			class="{{
				ProductData?.length > 0
					? 'absolute ltr:right-[-32px] rtl:left-0 top-0 px-2 '
					: 'flex justify-center items-center'
			}} bg-off-white cursor-pointer"
		>
			<button
				class="border-dashed border-[2px] border-[#D9DBE9] {{
					smallSize ? 'h-[132px]' : ' h-[200px]'
				}} rounded-12px {{
					ProductData?.length > 0
						? smallSize
							? 'w-[132px]'
							: 'w-[200px]'
						: 'w-full'
				}}"
				*ngIf="ProductData?.length >= 0 && ProductData?.length < 5"
			>
				<div>
					<img class="m-auto" src="./assets/images/upload.svg" alt="" />
					<p>{{ 'ACTIONS.UPLOAD_IMG' | translate }}</p>
				</div>
			</button>
		</div>
	</div>
</div>

<!-- Download button -->
